var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-input-group",
        [
          _c("b-form-input", {
            attrs: {
              id: "input_location_vacancy",
              size: "sm",
              state: _vm.state,
              disabled: _vm.isDisabled,
              placeholder:
                _vm.locationId && _vm.items.length === 0
                  ? "Нет доступных вакансий"
                  : "Выберите шаблон вакансии",
              autocomplete: "off"
            },
            on: { focus: _vm.onFocusIn, blur: _vm.onFocusOut },
            model: {
              value: _vm.query,
              callback: function($$v) {
                _vm.query = $$v
              },
              expression: "query"
            }
          }),
          _vm._v(" "),
          _c(
            "b-input-group-append",
            [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", disabled: !_vm.query || _vm.isDisabled },
                  on: { click: _vm.onClear }
                },
                [_c("font-awesome-icon", { attrs: { icon: "times-circle" } })],
                1
              ),
              _vm._v(" "),
              _vm.canEditLocationVacancies()
                ? _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.v-success",
                          modifiers: { hover: true, "v-success": true }
                        }
                      ],
                      attrs: {
                        size: "sm",
                        variant: "success",
                        disabled: _vm.isDisabled,
                        title: "Создать шаблон вакансии"
                      },
                      on: { click: _vm.showRecruitLocationVacancy }
                    },
                    [_c("font-awesome-icon", { attrs: { icon: "plus" } })],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.isFocus
            ? _c(
                "b-list-group",
                { staticClass: "autocomplete-input-location-vacancy" },
                [
                  _vm._l(_vm.filteredItems, function(item, index) {
                    return _c(
                      "b-list-group-item",
                      {
                        key: index,
                        attrs: { button: "" },
                        on: {
                          mousedown: function($event) {
                            return _vm.onClick(item)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "text-small" }, [
                          _vm._v(_vm._s(item.vacancy_name))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "text-secondary text-small" },
                          [_vm._v("Количество: " + _vm._s(item.workers_count))]
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.filteredItems.length === 0 && _vm.query
                    ? _c("b-list-group-item", { attrs: { disabled: "" } }, [
                        _c("small", [_vm._v("Ничего не найдено")])
                      ])
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("RecruitLocationVacancy", {
        ref: "recruit_location_vacancy",
        on: { refresh: _vm.getItems }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df86e5de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df86e5de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locations/LocationVacancySelect.vue
// module id = null
// module chunks = 